import { render } from "./ResendConfirmModal.vue?vue&type=template&id=3ed6d87c&scoped=true"
import script from "./ResendConfirmModal.vue?vue&type=script&lang=js"
export * from "./ResendConfirmModal.vue?vue&type=script&lang=js"

import "./ResendConfirmModal.vue?vue&type=style&index=0&id=3ed6d87c&scoped=true&lang=css"

import exportComponent from "/home/forge/newsletter.norden.org/releases/74710130/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ed6d87c"]])

export default __exports__